module.exports = __webpack_public_path__ + "img/newicon.12dde95d.png";